<template>
  <div class="row">
    <div class="col">
      <Toast />
      <Toast position="top-right" group="tl" />
    </div>
  </div>
  <div>
    <ConsulterChamp :narrationLocal="narrationLocal" :isDataLoading="isDataLoading" :numeroCardex="numeroCardex"
    :approuveLe="approuveLe" :creerLe="creerLe" :modifieLe="modifieLe"/>
    <div class="row">
      <div class="col-3">
        <Button @click="ShowHtml">{{labelHtml}}</Button>
      </div>
      <div class="col-6"/>
      <div class="col-3" v-if="isApprouvable && actionAccesDecision.approbationActionDecisionDO">
        <Button
            label="Approuver"
            @click="approuver"
            :disabled="isSauvegardeEnCours"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="col left scrollable">
          <vue-document-editor 
          id="editor"
          ref="editor"
          :key="componentKey"
          v-model:content="content" 
          :editable="false" 
          :page_format_mm="dimensions"/>
        </div>
      </div>
    </div>
    <ButtonBar :actionAccesDecision="actionAccesDecision" :modifierButton="modifierButton"
               :isPermettreModifier="isPermettreModifier" :isSauvegardeEnCours="isSauvegardeEnCours"
              @fermer="fermer" @approuver="approuver" @permettreModifier="permettreModifier"
              @auditModifications="auditModifications" @modifier="modifier" @imprimerNarration="imprimerNarration"/>
  </div>
</template>

<script>
import ButtonBar from '../../components/narration/Consulter/ButtonBar.vue'
import ConsulterChamp from '../../components/narration/Consulter/ConsulterChamp.vue'
import axios from 'axios';
import {mapGetters} from 'vuex';
import VueDocumentEditor from 'vue-document-editor';

export default {
  name: "NarrationConsulter",
  components: {
    ButtonBar,
    ConsulterChamp,
    VueDocumentEditor
  },
  mounted() {
    this.isDataLoading = true;
    this.$root.$refs.breadcrumbComp.ajout("Consulter Narration");
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.getNarration();
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      actionAccesDecision: 'narration/actionAccesDecision',
      dossier: 'dossier/dossier',
    })
  },
  data() {
    return {
      componentKey: 0,
      dimensions: [200, 800],
      pixelToMMConverter: 0.2645,
      narrationLocal: {},
      isDataLoading: false,
      isSauvegardeEnCours: false,
      isPermettreModifier: false,
      modifierButton: false,
      isApprouvable: false,
      isModifiable: false,
      isDoInactif: false,
      numeroCardex: null,
      approuveLe: null,
      creerLe: null,
      modifieLe: null,
      creerPar: null,
      content: [],
      showSansHtml: false,
      labelHtml : 'Consulter sans formatage'
    };
  },
  methods: {
    ShowHtml() {
      if(!this.showSansHtml) {
        this.content[0] = this.narrationLocal.texteSansHTML;
        this.labelHtml = "Consulter avec formatage";
        this.showSansHtml = true;
      }else {
        this.content[0] = this.narrationLocal.texteHTML;
        this.labelHtml = "Consulter sans formatage";
        this.showSansHtml = false;
      }
    },
    forceRerender() {
      this.componentKey += 1
    },
    assignerNarration(res) {
      this.narrationLocal = res.data.entite;
      this.isDoInactif = this.narrationLocal.genreReference.trim() === 'DO' && this.dossier.statut === 561
      this.approuveLe = this.$commun.formatDateHeure(res.data.entite.approuveLe);
      this.creerLe = this.$commun.formatDateHeure(res.data.entite.creerLe);
      this.modifieLe = this.$commun.formatDateHeure(res.data.entite.modifieLe);
      this.creerPar = res.data.entite.creerPar;
      this.isApprouvable = res.data.entite.approuvable && !this.isDoInactif;
      this.isModifiable = res.data.entite.modifiable;
      this.isPermettreModifier = res.data.entite.permettreModification && !this.isDoInactif;
      this.modifierButton = this.getModifierActionDecision();
      this.content[0] = this.narrationLocal.texteHTML;
      this.setHeightAndWidth();
      this.numeroCardex = this.dossier.numeroCardexAfficher;
    },
    setHeightAndWidth(){
      const tempDiv = document.getElementById('editor').querySelector('div.content')?.querySelector('div');
      tempDiv.innerHTML = this.narrationLocal.texteHTML;
      if(tempDiv != undefined && tempDiv.children != undefined){
        let totalHeight = 0;
        for(let i = 0; i < tempDiv.children.length; i++){
          const child = tempDiv.children[i];
          const height = child.clientHeight;
          totalHeight += height * this.pixelToMMConverter;
        }
        if(totalHeight > this.dimensions[1] - 30){
          this.dimensions[1] = totalHeight + 400;
          this.forceRerender();
        }
      }
    },
    getNarration() {
      this.$store
          .dispatch("narration/consulterAction", {
            cle: this.$route.params.cle,
            site: this.$route.params.site
          })
          .then((res) => {
            this.assignerNarration(res);
            this.isDataLoading = false;
          });
    },
    modifier() {
      this.$router.push({
        name: "narrationModifier",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        },
      });
    },
    auditModifications() {
      this.$router.push({
        name: "narrationAuditModifications",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        },
      });
    },
    permettreModifier() {
      this.isSauvegardeEnCours = true;
      this.isSauvegardeReussie = false;
      let erreurSauvegarde = false;
      this.narrationLocal.approuveLe = null;
      this.narrationLocal.isApprouvable = false;
      this.$store.commit('narration/UPDATE_NARRATION', this.narrationLocal);
      this.$store.dispatch('narration/sauvegarderAction').then((res) =>{
        this.$root.$refs.messagesComp.messages.splice(0);
        if(res.status == 200 || res.status == 202) {
          this.$root.$refs.messagesComp.messagesList = res.data.messageVOs;
          res.data.messageVOs.forEach(elem => {
            if(elem.severite == "error") {
              erreurSauvegarde = true;
            }
          });
          if(!erreurSauvegarde) {
            this.isSauvegardeReussie = true;
            this.$toast.add({severity:'success', summary: 'Sauvegarder', detail:'La narration a été modifiée.', life: 6000});
            this.getNarration();
          }
        } else {
          this.$toast.add({severity:'error', summary: 'Sauvegarder', detail:'Une erreur est survenue lors de la sauvegarde.', life: 6000});
        }
        this.isSauvegardeEnCours = false;
      });
    },
    approuver(){
      this.isSauvegardeEnCours = true;
      this.isSauvegardeReussie = false;
      let erreurSauvegarde = false;
      this.$store.dispatch('narration/approuverAction')
        .then((res) => {
          this.$root.$refs.messagesComp.messages.splice(0);
          if(res.status == 200 || res.status == 202) {
            this.$root.$refs.messagesComp.messagesList = res.data.messageVOs;
            res.data.messageVOs.forEach(elem => {
              if(elem.severite == "error") {
                erreurSauvegarde = true;
              }
            });
            if(erreurSauvegarde) {
              this.$toast.add({
                severity:'error',
                summary: 'Sauvegarder',
                detail:'Une erreur est survenue lors de la sauvegarde.',
                life: 6000
              });
            }
            else {
              this.isSauvegardeReussie = true;
              this.$toast.add({
                severity:'success',
                summary: 'Approuver',
                detail:'La narration a été approuvée.',
                life: 6000
              });
              this.getNarration();
            }
          }
          else {
            this.$toast.add({severity:'error', summary: 'Approuver', detail:'Une erreur est survenue lors de la approbation', life: 6000});
          }
          this.isSauvegardeEnCours = false;
        });
    },
    imprimerNarration() {
      let routeVersImpressionNarration = this.$router.resolve({
        name: 'narrationRapportCDX0015',
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        }})
      window.open(routeVersImpressionNarration.href)
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    getModifierActionDecision() {
      //un utilisateur devrait toujours pouvoir modifier sa propre narration si elle n'est pas approuvée.
      return this.isModifiable && (this.isApprouvable === false) && (this.narrationLocal.approuveLe === null) && !this.isDoInactif;
    }
  },
};
</script>